export default __webpack_public_path__ + "static/media/keto_appetite@2x.f3619aca.jpg";